import { Component } from '@angular/core';
import { SkipUserComponentUsageEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'User Component Usages') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipusercomponentusage-form',
    templateUrl: './skipusercomponentusage.form.component.html'
})
export class SkipUserComponentUsageFormComponent extends BaseFormComponent {
    public record!: SkipUserComponentUsageEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

